(function () {
	jQuery('.checkout-button').on('click', function(){
		jQuery.ajax({
			url:'/cart/clear.js',
			type: 'post',
			dataType: 'json',
			data: {},
			contentType: "application/json",
			success: function() {
				//
				var checkout_button = jQuery('button[data-testid="Checkout-button"]');
				if (checkout_button){
					checkout_button.click();
				}
			},
			error: function() {
				//
				console.log('fail');
			}
		});
	});
})();